import React from 'react';
import { render, screen } from '@testing-library/react';
import '@testing-library/jest-dom';
import Index from './index';

describe('Index', () => {
  test('renders Index component', () => {
    const purchases = '[{ "created_at": "9999/12/12", "valid_period_day": "90",'
                      +' "set_count": "1", "price": "2000", "init_count": "100",'
                      +' "consumed_count": "10", "expired_count": "10",'
                      +' "remain_count": "90", "issue_number": "100", "d_tickets_count": "1000",'
                      + ' "m_ticket": {"name": "100枚入りチケット"} }]'
    render(<Index purchases={purchases} />);

    screen.debug();
    expect(screen.getByText('100枚入りチケット')).toBeInTheDocument();
    expect(screen.getByText('発行日')).toBeInTheDocument();
  });
});
